<template>   
    <div class="col-md-4" >
        <div class="blog-entry animate-box" @mouseover="newShow=true" @mouseleave="newShow=false" >
            <div class="blog-img" style="background-image: url(ThemeMegazine/images/blog-5.jpg);">
                <div class="desc text-center side">
                    <p class="tag"><!--<span>Interactive</span>--></p>
                    <h2 :class="{'head-article':true, 'home-tile-head':(newShow===false)}" v-html="languageData['cloud']"></h2>
                    <transition name="slide-fade">
                        <div v-if="newShow" class="cloud_outer">
                            
                            <template v-for="(cloudText, kye) in tag_data" >
                                
                                <a :href="cloudText['link']"><span class="size_a" v-if="random_num[kye]==1" v-html="cloudText['heading']" :key=kye> </span></a>
                                
                                <a :href="cloudText['link']"><span class="size_b" v-if="random_num[kye]==2" v-html="cloudText['heading']" :key=kye> </span></a>
                                
                                <a :href="cloudText['link']"><span class="size_c" v-if="random_num[kye]==3" v-html="cloudText['heading']" :key=kye> </span></a>
                                
                                <a :href="cloudText['link']"><span class="size_d" v-if="random_num[kye]==4" v-html="cloudText['heading']" :key=kye> </span></a>
                                
                                <a :href="cloudText['link']"><span class="size_e" v-if="random_num[kye]==5" v-html="cloudText['heading']" :key=kye> </span></a>
                                
                                <a :href="cloudText['link']"><span class="size_f" v-if="random_num[kye]==6" v-html="cloudText['heading']" :key=kye> </span></a>
                            </template>
                            
                        </div>
                    </transition>
                    <br/>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {CONTENT_DOMAIN} from '@/constants/general_constants';
import axios from 'axios';
 
export default {
    name: 'TagClouds',
    data() {
        return {
            tag_data: [],
            random_num:[],
            newShow:false,
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN
           
        };
                
    },
    computed:{
        languageData(){return this.$store.state.languageData;}
    },
    components: {
           
        },
    created :function(){        
        this.generateRandom(),
        this.showCloudContent()     
    },
    methods:{
        showCloudContent(){
            var api_private_key=this.get_api_key_mix('clnt')
            axios.get(this.$store.state.apiUrl+'/cloud_content',{
                params:{
                    id_language:this.$store.state.companyData['id_language'],
                    id_company:this.$store.state.companyData['id_company'],
                    privatekey:api_private_key
                }
            })
            .then(response => {
                response = response.data
                //console.log(response);
                this.tag_data = response;
                this.$nextTick(function () {
                    
                })
            
            })
            .catch((error) => {
                this.tag_data = [];
                this.customErrorHandler(error.response.status);
            });
        },
        generateRandom(){
            var j
            for(j=0;j<8;j++){
                this.random_num[j] = Math.floor((Math.random() * 6) + 1);
            }
        }

    }
}
</script>
<style scoped>
.blog-entry .desc {
    background: #2f2f2fcc !important;
}
.blog-entry .side{
    margin-bottom: 0;
}
.category li a {
    border-bottom: 1px solid #c5c5c599 !important;
    display: block;
    padding: 5px 0;
    color: #dedede !important;
   
}
.category li {
    list-style: none !important;
}
.head-article{
    color: #dedede !important;
}
.btn-style{
    display: inline-block;
    bordeR: 1px solid rgba(255, 255, 255, 0.5);
    padding: 3px 11px;
    -webkit-border-radius: 16px;
    -moz-border-radius: 16px;
    -ms-border-radius: 16px;
    border-radius: 16px;
    color: #ffffff9e;
    font-size: 12px;
}
.btn-style:hover{
    border: 1px solid rgba(255, 255, 255, 0.82);
    color: #ffffffcf;
}
.size_a{
    font-size: 30px;
}
.size_b{
    font-size: 26px;
}
.size_c{
    font-size: 22px;
}
.size_d{
    font-size: 28px;
}
.size_e{
    font-size: 13px;
} 
.cloud_outer{    
    text-align: center;
}
.cloud_outer span{
    color: white;
    display: block;
    /*float: left;*/
    
}
</style>